module.exports = __webpack_public_path__ + "media/images/users/purchases/purchase_benefit_3_B-22576bfa8458486c49cd61db6db266cf.png";